import { atom } from "recoil";

export const selectedShapeState = atom({
  key: "selectedShapeState",
  default: {},
});
